import { useEffect, useRef, useState } from "react";

// @see https://davidwalsh.name/detect-sticky
// @see https://stackoverflow.com/a/64892655
const useOnScreen = ref => {
	const observerRef = useRef();
	const [isOnScreen, setIsOnScreen] = useState(false);

	useEffect(() => {
		observerRef.current = new IntersectionObserver(
			([entry]) => setIsOnScreen(entry.intersectionRatio < 1),
			{ threshold: [1] }
		);
	}, []);

	useEffect(() => {
		observerRef.current.observe(ref.current);

		return () => {
			observerRef.current.disconnect();
		};
	}, [ref]);

	return isOnScreen;
};

export default useOnScreen;
